module.exports = __webpack_public_path__ + "img/six_bg.3e7f3e46.jpg";